import { throttle } from "nodash"
import { useState, useEffect, useCallback } from "react"
import { MouseType } from "@nova/constants"

const defaultFramesPerMillisecond = 33

export default function useMouse() {
    const [mousePosition, setMousePosition] = useState<MouseType>()
    const [active, setActive] = useState(false)

    useEffect(() => {
        const updateMousePosition = throttle((mouseEvent) => {
            if (active) {
                setMousePosition({
                    x: mouseEvent.pageX,
                    y: mouseEvent.pageY,
                })
            }
        }, defaultFramesPerMillisecond)

        window.addEventListener("mousemove", updateMousePosition)

        return () => {
            window.removeEventListener("mousemove", updateMousePosition)
        }
    }, [active, setMousePosition])

    const setMouseListener = useCallback((shouldListen: boolean) => {
        setActive(shouldListen)
        if (!shouldListen) {
            setMousePosition(undefined)
        }
    }, [])

    return {
        mouse: mousePosition,
        setMouseListener,
        isMouseListening: active,
    }
}
